// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmable-link-container{display:flex;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./app/javascript/components/common/ConfirmableLink/ConfirmableLink.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
